import SparqlClient from 'sparql-http-client';

export interface UC1Senario2Table {
  date: any;
  usage: any;
  id: string;
  upload: number;
  download: number;
  claster: number;
}

const getDataSenario2Input = async (): Promise<UC1Senario2Table[]> => {
  const PROJECT_URL = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/datastores';
  const DATASET_URL = PROJECT_URL + '/input';
  const ENDPOINT_URL = DATASET_URL + '/sparql';
  const query = `
    PREFIX project: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix>
    PREFIX input: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/input>
    PREFIX output: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/output>

    SELECT ?S ?P ?O
    WHERE {
        ?S ?P ?O
    }
    LIMIT 100000
    `;
  const client = new SparqlClient({ endpointUrl: ENDPOINT_URL });
  const stream = client.query.select(query);
  const rawData: UC1Senario2Table[] = [];
  const dataMap: { [key: string]: { upload?: number; download?: number } } = {};

  const DOWNLINK_COLUMN_NAME = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/input/Downlink%20Total%20Traffic%20%28KBytes%29';
  const UPLINK_COLUMN_NAME = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/input/Uplink%20Total%20Traffic%20%28KBytes%29';
  const ITEM_PREFIX = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/input/item';

  return new Promise((resolve, reject) => {
    stream.on('data', (row: { [s: string]: any }) => {
      const id = row['S'].value.startsWith(ITEM_PREFIX) ? row['S'].value.slice(ITEM_PREFIX.length) : row['S'].value;
      const predicate = row['P'].value;
      const value = parseFloat(row['O'].value);

      if (!dataMap[id]) {
        dataMap[id] = { upload: 0, download: 0 };
      }

      if (predicate === DOWNLINK_COLUMN_NAME) {
        dataMap[id].download = value;
      } else if (predicate === UPLINK_COLUMN_NAME) {
        dataMap[id].upload = value;
      }
    });

    stream.on('end', () => {
      for (const id in dataMap) {
        rawData.push({
          id,
          upload: dataMap[id].upload ?? 0,
          download: dataMap[id].download ?? 0,
          claster: 0,
          date: undefined,
          usage: undefined,
        });
      }
      resolve(rawData);
    });

    stream.on('error', (err: any) => {
      console.error('Network error:', err);
      reject(new Error('Failed to fetch data from the SPARQL endpoint.'));
    });
  });
};

const getDataSenario2output = async (): Promise<{ id: string; claster: number }[]> => {
  const PROJECT_URL = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/datastores';
  const DATASET_URL = PROJECT_URL + '/output';
  const ENDPOINT_URL = DATASET_URL + '/sparql';
  const query = `
    PREFIX project: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix>
    PREFIX input: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/input>
    PREFIX output: <http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/output>

    SELECT ?S ?P ?O
    WHERE {
        ?S ?P ?O
    }
    LIMIT 100000
    `;
  const client = new SparqlClient({ endpointUrl: ENDPOINT_URL });
  const stream = client.query.select(query);
  const rawData: { id: string; claster: number }[] = [];

  const CLUSTER_COLUMN_NAME = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/output/Cluster';
  const ITEM_PREFIX = 'http://a5c626296a8ff492e8151c1e5cc7fc3a-726698208.eu-central-1.elb.amazonaws.com:12110/databrix/output/user';

  return new Promise((resolve, reject) => {
    stream.on('data', (row: { [s: string]: any }) => {
      const id = row['S'].value.startsWith(ITEM_PREFIX) ? row['S'].value.slice(ITEM_PREFIX.length) : row['S'].value;
      const predicate = row['P'].value;
      const value = parseInt(row['O'].value, 10);

      if (predicate === CLUSTER_COLUMN_NAME) {
        rawData.push({ id, claster: value });
      }
    });

    stream.on('end', () => {
      resolve(rawData);
    });

    stream.on('error', (err: any) => {
      console.error('Network error:', err);
      reject(new Error('Failed to fetch data from the SPARQL endpoint.'));
    });
  });
};

const getCombinedData = async (): Promise<UC1Senario2Table[]> => {
  try {
    const inputData = await getDataSenario2Input();
    const outputData = await getDataSenario2output();
    // Create a map for the output data to easily merge with input data
    const outputMap = new Map<string, number>();
    outputData.forEach((item) => {
      outputMap.set(item.id, item.claster);
    });

    // Merge the input data with the cluster information from the output data
    const combinedData = inputData.map((item) => ({
      ...item,
      claster: outputMap.get(item.id) ?? 0, // Default to 0 if no cluster info is found
    }));
    // console.log(combinedData)
    return combinedData;
  } catch (error) {
    console.error('Failed to fetch combined data:', error);
    throw new Error('Failed to fetch combined data');
  }
};

export default getCombinedData;
